import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { AdminGallery } from "@/components/admin/AdminGallery";
import { AdminCatalog } from "@/components/admin/AdminCatalog";
import { AdminAwards } from "@/components/admin/AdminAwards";
import { AdminInquiries } from "@/components/admin/AdminInquiries";
import { AdminSettings } from "@/components/admin/AdminSettings";
import { AdminStats } from "@/components/admin/AdminStats";
import { AdminLeads } from "@/components/admin/AdminLeads";
import { AdminTools } from "@/components/admin/AdminTools";
import { AdminChats } from "@/components/admin/AdminChats";
import { Monogram } from "@/components/site/Header";

const TABS = [
  ["estadisticas", "Estadísticas", AdminStats],
  ["interesados", "Interesados", AdminLeads],
  ["galeria", "Galería", AdminGallery],
  ["catalogo", "Catálogo", AdminCatalog],
  ["premios", "Premios", AdminAwards],
  ["consultas", "Consultas", AdminInquiries],
  ["chat", "Chat", AdminChats],
  ["configuracion", "Contacto", AdminSettings],
  ["herramientas", "Herramientas", AdminTools],
];

export default function Admin() {
  const { user, logout } = useApp();
  const [unread, setUnread] = useState(0);
  const refreshUnread = () => api.get("/admin/inquiries").then((r) => setUnread(r.data.filter((i) => !i.read).length)).catch(() => {});
  useEffect(() => { if (user) refreshUnread(); }, [user]);

  if (user === null) return <div className="p-10 text-[#5C635E]">Cargando…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#F8F5EE]" data-testid="admin-dashboard">
      <header className="bg-[#1D3324] text-stone-100">
        <div className="container-fv flex h-20 items-center justify-between">
          <div className="flex items-center gap-3">
            <Monogram />
            <div>
              <p className="f-display text-lg leading-tight">Panel de administración</p>
              <p className="text-xs text-stone-400">{user.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/" target="_blank" className="hidden sm:inline-flex items-center gap-2 text-sm px-3 py-2 hover:text-[#C5A059]" data-testid="admin-view-site"><ExternalLink size={16} />Ver sitio</Link>
            <button onClick={logout} data-testid="admin-logout-button" className="inline-flex items-center gap-2 text-sm px-3 py-2 hover:text-[#C5A059]"><LogOut size={16} />Salir</button>
          </div>
        </div>
      </header>
      <main className="container-fv py-10">
        <Tabs defaultValue="estadisticas">
          <TabsList className="h-auto flex-wrap justify-start bg-white border border-[#8B2B22]/10 p-1">
            {TABS.map(([v, label]) => (
              <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`} className="px-4 py-2 data-[state=active]:bg-[#8B2B22] data-[state=active]:text-white">
                {label}
                {v === "consultas" && unread > 0 && <span data-testid="admin-unread-badge" className="ml-2 rounded-full bg-[#C5A059] px-2 text-xs text-[#1A1E1B]">{unread}</span>}
              </TabsTrigger>
            ))}
          </TabsList>
          {TABS.map(([v, , C]) => (
            <TabsContent key={v} value={v} className="mt-8">
              <C onChange={refreshUnread} />
            </TabsContent>
          ))}
        </Tabs>
      </main>
    </div>
  );
}
